import * as React from "react";
import { isNull } from "lodash";
import { toastr } from "react-redux-toastr";
import { GoogleAnalyticsService } from "src/share/services/ga";

export interface IPageViewsResult {
  date: string;
  count: number;
}

export interface IGAViews {
  query: {
    ids: string;
  }
}

export interface IGAPageViewsProps {
  views: IGAViews;
  daysAgo: number | null;
  pagePath?: string;
  ready?: boolean;
}

export const useGAPageViews = (props: IGAPageViewsProps) => {
  const [pageViews, setPageViews] = React.useState<IPageViewsResult[] | null>(null);
  const getData = async () => {
    const { daysAgo, pagePath, ready, views } = props;
    try {
      if (!isNull(daysAgo) && (ready || ready === undefined)) {
        const data = await GoogleAnalyticsService.getViewsInfo(views.query.ids, daysAgo, pagePath);
        setPageViews(data);
      }
    } catch{
      toastr.error("Error", "There was an error loading the pages views from Google");
      setPageViews([]);
    }
  }
  React.useEffect(() => { getData() }, [props.daysAgo, props.pagePath, props.views.query.ids, props.ready])
  return { pageViews };
}


// WEBPACK FOOTER //
// ./src/share/components/GoogleAnalitycs/hooks/useGAPageViews.ts